var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4C3.10457 4 4 3.10457 4 2C4 0.895431 3.10457 0 2 0C0.89543 0 0 0.895431 0 2C0 3.10457 0.89543 4 2 4Z",
    transform: "translate(7.61914 18.1094)",
    fill: "#F7931E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4C3.10457 4 4 3.10457 4 2C4 0.895431 3.10457 0 2 0C0.895429 0 0 0.895431 0 2C0 3.10457 0.895429 4 2 4Z",
    transform: "translate(14.7998 18.1094)",
    fill: "#F7931E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6558 10.994H7.37953C7.03021 11.0226 6.68013 10.9482 6.37616 10.781C6.07219 10.6138 5.82886 10.3617 5.67873 10.0584L3.55761 1.97425C3.55068 1.942 3.53402 1.91241 3.5097 1.88913C3.48538 1.86584 3.45446 1.8499 3.42077 1.84326H1.11393C0.380828 0.94502 -0.557546 0 0.419927 0H19.5588C19.7922 0.00085059 20.0218 0.0557072 20.2282 0.159891C20.4346 0.264074 20.6116 0.414494 20.7441 0.598319C20.8766 0.782145 20.9607 0.993921 20.9892 1.21559C21.0177 1.43725 20.9897 1.66223 20.9078 1.87133L17.9753 10.0958C17.8775 10.3566 17.6987 10.5825 17.4627 10.7431C17.2268 10.9036 16.9452 10.9912 16.6558 10.994Z",
    transform: "translate(1 4)",
    stroke: "#1E334E",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.78 0H0",
    transform: "translate(7.71973 17.1797)",
    stroke: "#1E334E",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartIcon);
export default __webpack_public_path__ + "static/media/ShoppingCart_Icon.29af5ad55a1dc6e70478df3748979b2b.svg";
export { ForwardRef as ReactComponent };